// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"344":"f9abf54d","682":"d8899fb0","874":"48fdd8ce","886":"39d28a30"}[chunkId] + ".css";
};